import { DISPOSAL_PURPOSE, PRODUCT_TYPES } from '@schuettflix/interfaces';

export const productTypeToDisposalPurposeMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: undefined,
    CUSTOM_RECYCLED_BULK_MATERIAL: undefined,
    CUSTOM_CONCRETE: undefined,
    CUSTOM_ASPHALT: undefined,
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'DISPOSAL',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'RECYCLING',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'DISPOSAL',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'RECYCLING',
    // Transports
    CUSTOM_TRANSPORT: undefined,
    // Material Services
    CUSTOM_SERVICE: undefined,
    CUSTOM_SERVICE_ANALYSIS: undefined,
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: undefined,
    CUSTOM_SERVICE_TOLL: undefined,
    CUSTOM_SERVICE_WAITING_TIME: undefined,
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: undefined,
    RECYCLED_BULK_MATERIAL: undefined,
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'DISPOSAL',
    HAZARDOUS_WASTE_RECYCLING: 'RECYCLING',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'DISPOSAL',
    NON_HAZARDOUS_WASTE_RECYCLING: 'RECYCLING',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: undefined,
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: undefined,
    SERVICE_WEIGHING_NOTE: undefined,
    SERVICE_ACCOMPANYING_DOCUMENT: undefined,
    SERVICE_ENERGY_SURCHARGE: undefined,
} as const satisfies Record<PRODUCT_TYPES, DISPOSAL_PURPOSE | undefined>;
